/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_ProducerInputs */

const en_add_producer = /** @type {(inputs: Add_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Producer`)
};

const es_add_producer = /** @type {(inputs: Add_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar productor`)
};

/**
* | output |
* | --- |
* | "Add Producer" |
*
* @param {Add_ProducerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const add_producer = /** @type {((inputs?: Add_ProducerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_ProducerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_producer(inputs)
	return es_add_producer(inputs)
});